import isObject from 'lodash/isObject';

export const getYearFromTimestamp = timestamp => {
  let value = 0;
  if (typeof timestamp === 'string' || timestamp instanceof String) {
    value = +timestamp;
  } else {
    value = timestamp;
  }

  if (!Number.isNaN(value) && value > 0) {
    return new Date(value * 1000).getFullYear();
  }
  return null;
};

export const sortDeadlines = deadlines => {
  if (!Array.isArray(deadlines)) return [];

  const sorted = [...deadlines].filter(
    deadline =>
      isObject(deadline) &&
      'type' in deadline &&
      'month' in deadline &&
      'day' in deadline &&
      +deadline.month !== 0 &&
      +deadline.day !== 0,
  );

  const deadlinesFront = [];
  const deadlinesEnd = [];

  sorted.sort((a, b) => a.month - b.month || a.day - b.day);

  sorted.forEach(deadline => {
    const date = new Date();
    const today = new Date();

    // Set the date to the 1st of the month to avoid the month being unintentionally changed later due to overflow.
    date.setDate(1);
    date.setMonth(deadline.month - 1);
    date.setDate(deadline.day);

    if (
      today.getMonth() < date.getMonth() ||
      (today.getDate() <= date.getDate() && today.getMonth() <= date.getMonth())
    ) {
      deadlinesFront.push(deadline);
    } else {
      deadlinesEnd.push(deadline);
    }
  });

  return deadlinesFront.concat(deadlinesEnd);
};

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const shortMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

export const getMonthString = (monthIndex, shortHand) => {
  return shortHand ? shortMonths[monthIndex] : months[monthIndex];
};
